export default {
  SLUG: 'ws-link',
};
